export const createTimeout = (callback, interval) => {
  const intervalId = setTimeout(callback, interval);
  return () => clearTimeout(intervalId);
};